import { makeEnvironmentProviders } from '@angular/core';
import { OneTrustLoaderService } from './onetrust-loader.service';
import { ONE_TRUST_CONFIG, OneTrustConfig } from './one-trust.interface';
import { OneTrustService } from './one-trust.service';

function _provideOneTrust(config: OneTrustConfig) {
  return [
    OneTrustLoaderService,
    OneTrustService,
    { provide: ONE_TRUST_CONFIG, useValue: config },
  ];
}

export function provideOneTrust(config: OneTrustConfig) {
  return makeEnvironmentProviders(_provideOneTrust(config));
}
